import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { RestService } from '../../../../shared/services/rest.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { UserRepository } from '../../../user/states/user.repository';
import { AnimalVeterinaryContactModel, AnimalVeterinaryContactCreatePayload, AnimalVeterinaryContactUpdatePayload } from '../../models/medical/animal-veterinary-contact.model';
import { AnimalMedicalCrudRepository } from './animal-medical-crud.repository';

@Injectable({ providedIn: 'root' })
export class AnimalVeterinaryContactRepository extends AnimalMedicalCrudRepository<AnimalVeterinaryContactModel, AnimalVeterinaryContactCreatePayload, AnimalVeterinaryContactUpdatePayload> {
  protected readonly path = '/animal_veterinary_contacts';
  protected readonly toastKey = 'veterinaryContact';
  protected override readonly withCreator = false;

  constructor(
    restService: RestService,
    toast: ToastService,
    translateService: TranslocoService,
    userRepository: UserRepository
  ) {
    super(restService, toast, translateService, userRepository);
  }
}
